export default {
    book: 'Резервишите {product}',
    age_limit: 'Endast över {age}s',
    upgrade_product: 'Uppgradera produkt',
    choose_product: 'Välj {product}',
    days: '{count} dag | {count} dagar',
    login_register: 'Logga in/Registrera',
    keyless_benefits: {
        label: 'Direkt till bilen {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Full försäkring',
            zero_excess: 'Nollöverskott',
            phone_as_a_key: 'Telefon som nyckel',
            straight_to_car: 'Ingen väntan',
            no_queues: 'Inga köer',
            online_id_check: 'Id-kontroll online',
            self_checkout: 'Självutcheckning',
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/se/quotes/vehicle_card.js